
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h16v16H0z"}}),_c('path',{attrs:{"fill":"#9B84B8","d":"M8.016 1C5.511 1 3.5 3.123 3.5 5.734 3.5 8.972 6.727 14 8.016 14 9.125 14 12.5 8.972 12.5 5.734 12.5 3.124 10.489 1 8.016 1zm0 2.654c-1.082 0-1.948.94-1.948 2.058 0 1.143.866 2.057 1.948 2.057 1.059 0 1.949-.914 1.949-2.057 0-1.118-.89-2.058-1.949-2.058z"}})])])
          )
        }
      }
    